import React from "react";
import { StumpageTypeForm } from "../Stampage/AddStampage";

const AddConveyance = () => <StumpageTypeForm kind="conveyance" />;

export default AddConveyance;
